import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/medal-point.svg'
import _imports_1 from '@/assets/images/medal-point-red.svg'
import _imports_2 from '@/assets/images/medal.svg'
import _imports_3 from '@/assets/images/medal-point-gray.svg'


const _withScopeId = n => (_pushScopeId("data-v-a81b1ea2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "py-4 ps-lg-4 box-main bg-white side-info" }
const _hoisted_3 = { class: "col-md-11 fs-75 me-lg-5 me-0 px-4 px-lg-0 fw-bold" }
const _hoisted_4 = { class: "col-md-11 fs-75 me-lg-5 me-0 px-4 px-lg-0 while-spaces" }
const _hoisted_5 = { class: "col-md-11 fs-75 mb-4 me-lg-5 me-0 px-4 px-lg-0" }
const _hoisted_6 = { class: "col-md-11 fs-75 mb-4 me-lg-5 me-0 px-4 px-lg-0" }
const _hoisted_7 = {
  key: 0,
  class: "position-absolute position-medal"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  class: "position-absolute position-medal"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "d-flex total-achieved justify-content-center justify-content-lg-start" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box-medal rounded-2 text-center mb-lg-0 mb-2" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "medal"
  })
], -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box-medal rounded-2 text-center mb-lg-0 mb-2" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: "medal"
  })
], -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "box-sub text-center fw-bold text-white pt-lg-5 pt-3 d-flex flex-lg-column justify-content-center align-content-center" }
const _hoisted_19 = { class: "box-main-sub d-lg-flex align-items-center bg-white side-info d-none justify-content-center justify-content-lg-start ps-4" }
const _hoisted_20 = { class: "d-flex align-items-center bg-white d-lg-none justify-content-center justify-content-lg-start py-3 fs-75" }
const _hoisted_21 = { class: "d-flex mb-2 mb-lg-0" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "medal"
}, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "medal"
}, null, -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { class: "box-two-sub text-center fw-bold text-white pt-2 d-flex flex-lg-column justify-content-center align-content-center mb-lg-2 mb-0" }
const _hoisted_27 = { class: "fs-7 ms-3 ms-lg-0" }

import { translate } from '@/languages/i18n'
import { ref, watchEffect } from 'vue'
import { computed, ComputedRef } from 'vue-demi'
import { ROOT_STORE } from '@/store/constants'
import { useStore } from 'vuex'
import _ from 'lodash'

export default /*#__PURE__*/_defineComponent({
  props: {
  data: Object,
},
  setup(__props) {

const props = __props


const store = useStore()
const isMobile = computed<ComputedRef<boolean>>(() => store.getters[ROOT_STORE.GETTERS.CHECK_MOBILE_DEVICE])
const countItemAchieved = ref<number>(0)
//2022/10/05 CW-VietNC Fix for UAT Phase2#4502: SJ10 (Ph2-R202201014)
const countNotItemAchieved = computed(() => {
  if (_.isInteger(props.data?.communities?.length) && _.isInteger(countItemAchieved.value)) {
    return props.data?.communities?.length - countItemAchieved.value
  }
  return 0
})
// 達成数を集計する
// 達成数がボーダーをオーバーしてた場合ボーダー数を返す(3/2達成と表示されるのを防ぐため)
const calculateAchievedCount = (border: any, count: any) => {
  return border < count ? border : count
}
// 達成していない数を集計する
// 達成数がボーダーをオーバーしてた場合0を返す(v-forにマイナス値を渡すとエラーになるため)
const calculateNotAchievedCount = (border: any, count: any) => {
  return 0 > border - count ? 0 : border - count
}
watchEffect(() => {
  countItemAchieved.value = props.data?.communities?.filter((e) => e?.achieved)?.length
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(['d-flex flex-lg-row flex-column position-relative box-container  rounded-4', countItemAchieved.value === __props.data?.communities?.length ? 'side-point-active' : 'side-point'])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(translate)('SJ10title4')), 1),
          _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(translate)('SJ10title5')), 1),
          _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(translate)('SJ10title6')), 1),
          _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(translate)('SJ10title7')), 1),
          (countItemAchieved.value !== __props.data?.communities?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12)),
          _createElementVNode("div", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(countItemAchieved.value, (item) => {
              return (_openBlock(), _createElementBlock("div", { key: item }, _hoisted_15))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(countNotItemAchieved), (item_not_active) => {
              return (_openBlock(), _createElementBlock("div", { key: item_not_active }, _hoisted_17))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("span", {
            class: _normalizeClass(_unref(isMobile) ? '' : 'mt-lg-5 mt-0')
          }, _toDisplayString(countItemAchieved.value) + "/" + _toDisplayString(__props.data?.communities?.length), 3),
          _createElementVNode("p", {
            class: _normalizeClass(['fs-7 ms-3', _unref(isMobile) ? '' : 'ms-lg-0'])
          }, _toDisplayString(countItemAchieved.value === __props.data?.communities?.length ? '達成' : '未達成'), 3)
        ])
      ], 2)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data?.communities, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item,
        class: "d-flex justify-content-center mt-4"
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(['shadow d-flex flex-lg-row flex-column fw-bold rounded-4 box-container-sub ', item?.achieved ? 'side-point-active ' : 'side-point'])
        }, [
          _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(translate)(`SJ10${item?.mission_code}`)), 1),
          _createElementVNode("div", {
            class: _normalizeClass(['bg-white d-flex align-items-center justify-content-lg-end flex-column flex-lg-row side-other', item?.achieved ? 'box-main-sub-3 ' : 'box-main-sub-2 '])
          }, [
            _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(translate)(`SJ10${item?.mission_code}`)), 1),
            _createElementVNode("div", _hoisted_21, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(calculateAchievedCount(item?.achievement_border, item?.achievement_count), (border_active) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "box-medal rounded-2 text-center me-2",
                  key: border_active
                }, _hoisted_23))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(calculateNotAchievedCount(item?.achievement_border, item?.achievement_count), (border) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "box-medal rounded-2 text-center me-2",
                  key: border
                }, _hoisted_25))
              }), 128))
            ])
          ], 2),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("span", null, _toDisplayString(calculateAchievedCount(item?.achievement_border, item?.achievement_count)) + "/" + _toDisplayString(item?.achievement_border), 1),
            _createElementVNode("p", _hoisted_27, _toDisplayString(item?.achieved ? '達成' : '未達成'), 1)
          ])
        ], 2)
      ]))
    }), 128))
  ], 64))
}
}

})